import React, { useState, useEffect } from 'react'
import { Row, Col, Modal } from 'react-bootstrap';
import { makeRequest } from '../../utils/makeRequest';
import toastNotify from '../../utils/toastNotify';
import * as urls from "../../utils/urlConst";
import { BiFile } from "react-icons/bi";
import Loader from '../../components/Loader';
import { exceptionLog } from '../../utils/common';


const ArticleDtlMdl: React.FC<any> = ({ isArticleDtl, setIsArticle, data, setSelectedArticle }) => {
    const [isArticleLoader, setIsArticleLoader] = useState<boolean>(false);
    const [articleList, setArticleList] = useState<any[]>([]);

    const fetchArticles = async () => {
        try {
            setIsArticleLoader(true);
            const payload = {
                CategoryCode: "0",
                SubCategoryCode: "0",
                ArticleType: "G",
            };

            const config = {};

            await makeRequest("POST", urls.getArticleList, payload, config).then((result) => {
                if (result.STATUS === '0') {
                    const response = result.RESPONSE;
                    setArticleList(response);
                } else {
                    setArticleList([]);
                    result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
                }
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Get article", "N");
            }
        } finally {
            setIsArticleLoader(false);
        }
    };

    useEffect(() => {
        fetchArticles();
    }, [])

    return (
        <div>
            <Modal
                show={isArticleDtl}
                onHide={() => { setIsArticle(!isArticleDtl); setSelectedArticle() }}
                backdrop="static"
                keyboard={false}
                className='addBranchModel'
                size='xl'
            >
                <Modal.Header closeButton>
                    <div>
                        <h2 className="text-sm mb-0"> {data?.Topic}</h2>
                        <div className='text-slate-500 text-xs'>Updated Date : {data?.UpdatedDate}</div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ minHeight: '40vh' }}>
                    {!isArticleLoader ?
                        <Row>
                            <Col md={articleList.length !== 0 ? 9 : 12}>
                                <div className='Pop-up'>
                                    <div className='ql-editor'>
                                        <div dangerouslySetInnerHTML={{ __html: data.Description }} />
                                    </div>
                                </div>
                            </Col>
                            <Col md={articleList.length !== 0 ? 3 : 0} className={`d-none d-md-block ${articleList.length === 0 ? "d-none" : ""}`}>
                                <div>
                                    <h1 className="text-base pb-2 fw-semibold mb-2 border-bottom">
                                        Articles
                                    </h1>
                                    {articleList.length !== 0 ?
                                        <ul style={{ listStyle: "none" }} className="ps-0">
                                            {articleList.map((data: any, id: number) => (
                                                <li key={id} className="d-flex align-items-center gap-2 mt-2 text-sm article-list"
                                                    onClick={() => setSelectedArticle(data)}
                                                >
                                                    <BiFile />
                                                    <div style={{ width: "100%", textOverflow: "ellipsis", overflow: "hidden", textWrap: "nowrap" }}>{data.Topic}</div>
                                                </li>
                                            ))}
                                        </ul>
                                        :
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: "40vh" }}>
                                            <div>
                                                <img src="/images/noDataFound.png" alt="No Data Found" style={{ width: 150 }} />
                                                <h1 className="text-sm text-center">No article found</h1>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Col>
                        </Row>
                        :
                        <div style={{ height: '40vh' }} className='d-flex justify-content-center align-items-center'>
                            <Loader />
                        </div>
                    }
                </Modal.Body>
            </Modal >
        </div >
    )
}

export default ArticleDtlMdl;
